import { render, staticRenderFns } from "./CheckBoxIOS.vue?vue&type=template&id=424561f3&scoped=true"
import script from "./CheckBoxIOS.vue?vue&type=script&lang=js"
export * from "./CheckBoxIOS.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxIOS.vue?vue&type=style&index=0&id=424561f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424561f3",
  null
  
)

export default component.exports